export default __webpack_public_path__ + "static/media/icon-cardio.ef6be642.png";